import { render, staticRenderFns } from "./OrdersRetail.vue?vue&type=template&id=47af2760&scoped=true&"
import script from "./OrdersRetail.vue?vue&type=script&lang=js&"
export * from "./OrdersRetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47af2760",
  null
  
)

export default component.exports